export default function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-8 h-8 rounded-full border-4 border-[#0E7C86]/20 border-t-[#0E7C86] animate-spin" />
    </div>
  )
}
